module.exports = __webpack_public_path__ + "static/media/luxury-icon.466955be.svg";